<!-- <app-title *ngIf="pool" [title]="pool.getName()"></app-title> -->

<!-- <div class="d-flex justify-content-between mb-4 mt-2">
  <h2 class="text-center">
    <fa-icon [icon]=faUsers></fa-icon> spelers kiezen
  </h2>
  <button (click)="close.emit()" type="button" class="btn btn-outline-dark">
    <span class="fs-4">&times;</span>
  </button>
</div> -->



<!-- <ngb-alert *ngIf="alert" [type]="alert.type">
  {{ alert.message }}</ngb-alert> -->

@if(!processing()) {
  @if(viewPeriod()) {
    <form name="form" (ngSubmit)="false" [formGroup]="form" novalidate>
      <div class="d-flex justify-content-around">
        <select class="form-control me-1" formControlName="searchTeam" (change)="updateFilter()">
          <option [ngValue]="undefined" selected>
            alle clubs
          </option>
          @for (team of selectableTeams(); track team.getId()) {
          <option [ngValue]="team">{{team.getName()}}</option>
          }
        </select>
        <select class="form-control ms-1" formControlName="searchLine" (change)="updateFilter()">
          <option [ngValue]="undefined" selected>
            alle linies
          </option>
          @for (line of selectableLines(); track line) {
          <option [ngValue]="line">{{nameService.getFormationLineName(line)}}</option>
          }
        </select>
      </div>
    </form>
  
    <table class="table">
      <tbody>
        @for (choosePersonItem of choosePersonItems(); track choosePersonItem) {    
          @if(showAll() || isChoosable(choosePersonItem.player)) {
            <tr (click)="linkToPlayer(choosePersonItem)" class="pointer">
              <td>
                <app-lineicon [line]="choosePersonItem.player.getLine()"></app-lineicon>
              </td>
              <td>
                {{choosePersonItem.player.getPerson().getName()}}
              </td>
              <td>
                <app-team-name [team]="choosePersonItem.player.getTeam()"></app-team-name>
              </td>
              <td class="text-end pe-0">
                <se-marketvalue [marketValue]="choosePersonItem.player.getMarketValue()"></se-marketvalue>
              </td>
              <td class="text-end pe-0">
                <span class="badge bg-totals">{{getTotalPoints(choosePersonItem.s11Player)}}</span>
              </td>
              @if(showSelectButton()) {
                <td class="text-end" (click)="$event.stopPropagation()">
                @if(isChoosable(choosePersonItem.player)) {
                  <button type="button" class="btn btn-primary btn-sm"
                    (click)="select(choosePersonItem.s11Player,choosePersonItem.player)">
                    <fa-icon [icon]=faChevronRight></fa-icon>
                  </button>
                }
                </td>
              }
            </tr>
          }
        }
      </tbody>
    </table>
  }
} @else {
  <h2 class="text-center">
    <fa-icon [icon]=faSpinner [animation]="'spin'"></fa-icon>
  </h2>
}